import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/components/pageWrappers/pageWrapper.scss';
import Footer from '../footer/Footer';
import SidebarTheme1 from '../sidebar/SidebarTheme1';
import { RootState } from '../../store/store';
import { useSelector } from 'react-redux';
import { sellerAllSidebarLinks } from '../../lib/constants/sidebarLinks';
import { usePlanLock } from '../../lib/plan-lock/usePlanLock';
import { LOCKED_SETTINGS_LINKS } from '../../lib/plan-lock/plan-lock-rules';

const PageWrapper: React.FC = ({ children }) => {
  const { t } = useTranslation();
  const isSidebarDrawerOpen = useSelector(
    (state: RootState) => state.UI.isSidebarDrawerOpen
  );

  // No active plan or trial: only Subscription and Profile stay in the menu.
  const { locked: isPlanLocked } = usePlanLock();
  const sidebarLinks = isPlanLocked
    ? sellerAllSidebarLinks.filter((link) =>
        LOCKED_SETTINGS_LINKS.includes(link.link)
      )
    : sellerAllSidebarLinks;

  return (
    <div className='pageWrapper--outer'>
      <div className='pageWrapper'>
        <div className='pageWrapper__content'>
          <div
            data-is-sidebar-open={isSidebarDrawerOpen?.toString()}
            className='pageWrapper__content--sidebar'
          >
            <SidebarTheme1 items={sidebarLinks} />
          </div>
          <div className='pageWrapper__content--page'>{children}</div>
        </div>
      </div>
      <div className='pageWrapper--footer'>
        <Footer />
      </div>
    </div>
  );
};

export default PageWrapper;
